<app-kontable title = "{{ 'provinceList.sectionTitle' | translate }}"
              [columns] = "['id', 'code', 'name', 'country', 'state']"
              [titles] = "['common.id', 'common.code', 'common.name', 'common.country', 'common.state']"
              [showInfoButton]="false"
              [showRecoverButton]="true"
              [showGlobalFilter]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [source]="provinces"
              (onAdd)="showAddOrEditDialog($event)"
              (onEdit)="showAddOrEditDialog($event)"
              (onRemove)="delete($event)"
              [(fireNewDataAvailable)]="newDataAvailable"
></app-kontable>

<p-dialog *ngIf="show.modal"
          [width]="500"
          [(visible)]="show.modal"
          header="{{modalTitle}}"
          showEffect="fade"
          [modal]="true">

    <kv-province-form [dialogBoxProvince]="selectedProvince"
                      (provinceAdded)="provinceAdded($event)"
                      (provinceUpdated)="provinceUpdated($event)">
    </kv-province-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/province/province.component.html